import { IAppointment } from '../constants/types';

/** Department label for the outpatient appointments table in Search / dossier modals. */
export function getAppointmentDepartmentName(appointment: IAppointment): string {
    return appointment.agenda?.department?.name ?? '';
}

/**
 * Show-up (check-in) returns a slim appointment payload. Keep nested agenda data from
 * the list response so re-rendering the table does not crash on agenda.department.
 */
export function mergeAppointmentAfterCheckIn(
    existing: IAppointment,
    updated: IAppointment,
): IAppointment {
    return {
        ...existing,
        ...updated,
        agenda: updated.agenda ?? existing.agenda,
        requestAppointment: {
            ...existing.requestAppointment,
            ...updated.requestAppointment,
        },
    };
}
